import { 
  Table, 
  Thead, 
  Tbody, 
  Tr, 
  Th, 
  Td, 
  Box 
} from '@chakra-ui/react'

export const EventLog = () => {
  const events = [
    {
      timestamp: '2024-01-16 14:30:00',
      criticalValue: '95.5°C',
      alertType: 'Temperature Warning',
      systemStatus: 'Alert'
    },
    // Add more sample data as needed
  ]

  return (
    <Box overflowX="auto">
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Timestamp</Th>
            <Th>Critical Value</Th>
            <Th>Alert Type</Th>
            <Th>System Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {events.map((event, index) => (
            <Tr key={index}>
              <Td>{event.timestamp}</Td>
              <Td>{event.criticalValue}</Td>
              <Td>{event.alertType}</Td>
              <Td>{event.systemStatus}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  )
} 